export default __webpack_public_path__ + "static/media/Path3426.d93d6cc8.svg";